<platform-page-layout bannerClasses="hive-page">
    <hive-app-navigation
        #nav
        aria-label="Main"
        storageKey="pure1"
        legalUrl="https://www.purestorage.com/legal/productenduserinfo.html"
        [activeItemId]="activeItemId()"
        (activeItemIdChange)="activeItemIdChange.emit($event)"
        [(expandedItemIds)]="expandedItemIds"
        (collapseToggle)="collapseToggle.emit($event)"
    >
        <hive-app-navigation-header>
            <a hiveAppNavigationLogo routerLink="/">
                <img src="images/pure1-full-logo-dark.svg" [alt]="PRODUCT_NAMES.PURE1" />
            </a>
            <a hiveAppNavigationLogoCollapsed routerLink="/">
                <img src="images/pure1-icon-logo-dark.svg" [alt]="PRODUCT_NAMES.PURE1" />
            </a>

            <!-- Hive matches header slots on direct children, which an @if block is not. -->
            <ng-container ngProjectAs="[hiveAppNavigationHeaderAction]">
                <!-- Proactive recommendations -->
                @if (showRecommendations()) {
                    <button
                        hive-app-navigation-action
                        hiveAppNavigationHeaderAction
                        type="button"
                        aria-label="Recommendations"
                        title="Recommendations"
                        [count]="recommendationCount()"
                        (click)="recommendationsClick.emit()"
                    >
                        <hive-icon-component [icon]="faLightbulb" />
                    </button>
                }
            </ng-container>

            <hive-app-navigation-notifications
                #notifications
                ariaLabel="Notifications"
                [count]="notificationCount()"
                (clicked)="ampli.notificationsClicked()"
            >
                <ng-template hiveAppNavigationPopupContent>
                    <nc-notification-popup
                        [showAlerts]="true"
                        (closePopup)="notifications.close()"
                    ></nc-notification-popup>
                </ng-template>
            </hive-app-navigation-notifications>

            <platform-app-navigation-user-profile hiveAppNavigationHeaderAction />

            <ng-container ngProjectAs="hive-org-switcher">
                @if (showOrgSwitcher()) {
                    <hive-org-switcher
                        p1mOrgSwitcher
                        #orgSwitcher="p1mOrgSwitcher"
                        [selectedOrganizationLabel]="orgSwitcher.orgLabel$ | async"
                        [selectedCompanyLabel]="orgSwitcher.companyLabel$ | async"
                        [selection]="orgSwitcher.activeOrg$ | async"
                        [isLoading]="orgSwitcher.isLoading$ | async"
                        [hasLoadingError]="orgSwitcher.hasLoadingError$ | async"
                        [hasFilterAutofocus]="true"
                        [debounceWait]="orgSwitcher.filterDebounceWait"
                        [disabled]="isOrgSwitcherReadonly()"
                        (switchError)="orgSwitchError.emit($event)"
                        (mouseenter)="orgListRendered.set(true)"
                        (focusin)="orgListRendered.set(true)"
                        (visibilityChange)="orgListRendered.set($event)"
                        hiveTooltip
                        [hiveTooltipDescription]="
                            isOrgSwitcherReadonly()
                                ? 'The selected context is displaying cross-organization data, so the Organization Switcher is not applicable.'
                                : undefined
                        "
                    >
                        <!-- Rendered only while the switcher is in use; see orgListRendered. -->
                        @if (orgListRendered()) {
                            @for (section of orgSwitcher.groups$ | async; track section.name) {
                                <hive-selection-menu-section [label]="section.name">
                                    @for (item of section.items; track item.uid) {
                                        <hive-selection-menu-item [label]="item.name" [value]="item" />
                                    }
                                </hive-selection-menu-section>
                            }
                        }
                    </hive-org-switcher>
                }
            </ng-container>

            <ng-container ngProjectAs="hive-app-navigation-back-button">
                @if (activeNavigation() === 'draas') {
                    <hive-app-navigation-back-button
                        [label]="'Back to ' + PRODUCT_NAMES.PURE1"
                        (clicked)="backClick.emit()"
                    />
                }
            </ng-container>

            <fusion-status-menu-item slot="header-content" [collapsed]="nav.collapsed()" />
        </hive-app-navigation-header>

        <hive-app-navigation-body>
            <ng-template #tagContent let-tab="tab" let-subTab="subTab">
                <!-- Badge: AI Copilot -->
                @if (tab.title === 'AI Copilot') {
                    <hive-tag label="New" severity="info"></hive-tag>
                }
                @if (tab.title === 'Dashboard' && subTab?.title === 'Points of View') {
                    <hive-tag label="Beta" severity="info"></hive-tag>
                }
            </ng-template>
            <ng-template #badgeContent let-tab="tab" let-subTab="subTab">
                <!-- SIDENAV BADGES -->

                <!-- Dashboard - Assessments: New Virtualization assessment -->
                @if (tab.title === 'Dashboard' && subTab?.title === 'Assessment' && isVmAssessmentsBetaEnabled()) {
                    <hive-badge label="new"></hive-badge>
                }

                <!-- MARKETPLACE - Recommendations -->
                @if (recommendationCount() > 0 && tab.title === 'Marketplace' && subTab?.title === 'Recommendations') {
                    <hive-badge
                        [label]="recommendationCount()"
                        hiveTooltip
                        hiveTooltipDescription="You have {{ recommendationCount() }} {{
                            recommendationCount() | pluralize: 'recommendation'
                        }} to review."
                    ></hive-badge>
                }

                <!-- Fleet - Appliances: EOL -->
                @if (
                    !isEOSCEnabled() &&
                    tab.title === 'Fleet' &&
                    (subTab?.title === 'Appliances' || subTab?.title === 'Resources') &&
                    showEolApplianceBadge()
                ) {
                    <hive-badge
                        [label]="eolApplianceCount()"
                        hiveTooltip
                        hiveTooltipDescription="You have {{ eolApplianceCount() }} {{
                            eolApplianceCount() | pluralize: 'appliance'
                        }} approaching their end-of-life."
                        emphasis="info"
                    ></hive-badge>
                }
                <!-- Fleet - Appliances:  EOL OR EOSC -->
                @if (
                    isEOSCEnabled() &&
                    tab.title === 'Fleet' &&
                    (subTab?.title === 'Appliances' || subTab?.title === 'Resources') &&
                    showEolOrEoscApplianceBadge()
                ) {
                    <hive-badge
                        [label]="eolOrEoscApplianceCount()"
                        hiveTooltip
                        hiveTooltipDescription="You have {{ eolOrEoscApplianceCount() }} {{
                            eolOrEoscApplianceCount() | pluralize: 'appliance'
                        }} {{ eolOrEoscApplianceTooltip() }}"
                        emphasis="info"
                    ></hive-badge>
                }

                <!-- Fleet - Subscriptions: Expired contracts -->
                @if (
                    !isEOSCEnabled() &&
                    tab.title === 'Fleet' &&
                    subTab?.title === 'Subscriptions' &&
                    expiredSupportContractCount() > 0
                ) {
                    <hive-badge
                        class="sidebar-badge subtab-link-badge"
                        [label]="expiredSupportContractCount()"
                        emphasis="info"
                        hiveTooltip
                        hiveTooltipDescription="You have {{ expiredSupportContractCount() }} {{
                            expiredSupportContractCount() | pluralize: 'appliance'
                        }} with {{ expiredSupportContractCount() > 1 ? 'expired contracts' : 'an expired contract' }}"
                    ></hive-badge>
                }

                <!-- Fleet - Appliances: Disconnected arrays -->
                @if (
                    tab.title === 'Fleet' &&
                    (subTab?.title === 'Appliances' || subTab?.title === 'Resources') &&
                    (isEOSCEnabled() ? !showEolOrEoscApplianceBadge() : !showEolApplianceBadge()) &&
                    showArrayCountBadge()
                ) {
                    <hive-badge
                        label="{{ arrayCounts().connected }} of {{
                            arrayCounts().disconnected + arrayCounts().connected
                        }}"
                        hiveTooltip
                        hiveTooltipDescription="You have {{ arrayCounts().disconnected }} {{
                            arrayCounts().disconnected | pluralize: 'array that has' : 'arrays that have'
                        }}
                    not been updated recently."
                    ></hive-badge>
                }

                <!-- Messages - Alerts: Number of open alerts -->
                @if (tab.title === 'Messages' && subTab?.title === 'Alerts' && openAlertsCount() > 0) {
                    <hive-badge
                        class="sidebar-badge subtab-link-badge"
                        label="{{ openAlertsCount() }}"
                        [emphasis]="alertsEmphasisBadge()"
                    ></hive-badge>
                }

                <!-- Support - Cases: Number of open cases -->
                @if (tab.title === 'Support' && openCasesCount() > 0) {
                    <hive-badge class="sidebar-badge subtab-link-badge" [label]="openCasesCount()"></hive-badge>
                }

                <!-- Administration - Fleet: New Fusion Fleet page -->
                @if (tab.title === 'Administration' && subTab?.title === 'Fleet') {
                    <hive-tag label="new" severity="info"></hive-tag>
                }
            </ng-template>

            @for (tab of tabs(); track tab.title) {
                @if (tab.title === MENU_SEPARATOR_TITLE) {
                    <hive-separator />
                } @else if (tab.subTabs?.length > 0) {
                    <a
                        hive-app-navigation-item
                        [id]="tab | navMenuId"
                        [label]="tab.title"
                        [icon]="tab.icon"
                        [iconHighlighted]="tab.iconHighlighted"
                        [routerLink]="tab.path"
                        attr.data-pw="item-{{ tab.title.toLowerCase() }}"
                    >
                        <ng-container
                            *ngTemplateOutlet="tagContent; context: { tab: tab, subTab: null }"
                            ngProjectAs="hive-tag"
                        />
                        <ng-container
                            *ngTemplateOutlet="badgeContent; context: { tab: tab, subTab: null }"
                            ngProjectAs="hive-badge"
                        />
                        <ng-container ngProjectAs="hive-app-navigation-item">
                            @for (subTab of tab.subTabs; track subTab.title) {
                                @if (subTab.subTabs?.length > 0) {
                                    <hive-app-navigation-item
                                        [id]="subTab | navMenuId"
                                        [label]="subTab.title"
                                        attr.data-pw="sub-item-{{ tab.title.toLowerCase() }}-{{
                                            subTab.title.toLowerCase()
                                        }}"
                                    >
                                        <ng-container
                                            *ngTemplateOutlet="tagContent; context: { tab: tab, subTab: subTab }"
                                            ngProjectAs="hive-tag"
                                        />
                                        <ng-container
                                            *ngTemplateOutlet="badgeContent; context: { tab: tab, subTab: subTab }"
                                            ngProjectAs="hive-badge"
                                        />
                                        <!-- Subtabs of subtabs! Contains no tag or badges -->
                                        <ng-container ngProjectAs="hive-app-navigation-item">
                                            @for (subsubTab of subTab.subTabs; track subsubTab.title) {
                                                <a
                                                    hive-app-navigation-item
                                                    [id]="subsubTab | navMenuId"
                                                    [label]="subsubTab.title"
                                                    [routerLink]="subsubTab.path"
                                                    (click)="ampli.appNavigationItemClicked({ item: subsubTab.title })"
                                                    attr.data-pw="sub-sub-item-{{ tab.title.toLowerCase() }}-{{
                                                        subTab.title.toLowerCase()
                                                    }}-{{ subsubTab.title.toLowerCase() }}"
                                                ></a>
                                            }
                                        </ng-container>
                                    </hive-app-navigation-item>
                                } @else if (subTab.href) {
                                    <a
                                        hive-app-navigation-item
                                        [id]="subTab | navMenuId"
                                        [label]="subTab.title"
                                        [attr.href]="subTab.href"
                                        target="_blank"
                                        (click)="ampli.appNavigationItemClicked({ item: subTab.title })"
                                        attr.data-pw="sub-item-{{ tab.title.toLowerCase() }}-{{
                                            subTab.title.toLowerCase()
                                        }}"
                                    >
                                        <ng-container
                                            *ngTemplateOutlet="tagContent; context: { tab: tab, subTab: subTab }"
                                            ngProjectAs="hive-tag"
                                        />
                                        <ng-container
                                            *ngTemplateOutlet="badgeContent; context: { tab: tab, subTab: subTab }"
                                            ngProjectAs="hive-badge"
                                        />
                                    </a>
                                } @else {
                                    <a
                                        hive-app-navigation-item
                                        [id]="subTab | navMenuId"
                                        [label]="subTab.title"
                                        [routerLink]="subTab.path"
                                        (click)="ampli.appNavigationItemClicked({ item: subTab.title })"
                                        attr.data-pw="sub-item-{{ tab.title.toLowerCase() }}-{{
                                            subTab.title.toLowerCase()
                                        }}"
                                    >
                                        <ng-container
                                            *ngTemplateOutlet="tagContent; context: { tab: tab, subTab: subTab }"
                                            ngProjectAs="hive-tag"
                                        />
                                        <ng-container
                                            *ngTemplateOutlet="badgeContent; context: { tab: tab, subTab: subTab }"
                                            ngProjectAs="hive-badge"
                                        />
                                    </a>
                                }
                            }
                        </ng-container>
                    </a>
                } @else if (tab.href) {
                    <a
                        hive-app-navigation-item
                        [id]="tab | navMenuId"
                        [label]="tab.title"
                        [icon]="tab.icon"
                        [iconHighlighted]="tab.iconHighlighted"
                        [attr.href]="tab.href"
                        [target]="tab.target"
                        (click)="ampli.appNavigationItemClicked({ item: tab.title })"
                        attr.data-pw="item-{{ tab.title.toLowerCase() }}"
                    >
                        <ng-container
                            *ngTemplateOutlet="tagContent; context: { tab: tab, subTab: null }"
                            ngProjectAs="hive-tag"
                        />
                        <ng-container
                            *ngTemplateOutlet="badgeContent; context: { tab: tab, subTab: null }"
                            ngProjectAs="hive-badge"
                        />
                    </a>
                } @else {
                    <a
                        hive-app-navigation-item
                        [id]="tab | navMenuId"
                        [label]="tab.title"
                        [icon]="tab.icon"
                        [iconHighlighted]="tab.iconHighlighted"
                        [routerLink]="tab.path"
                        (click)="ampli.appNavigationItemClicked({ item: tab.title })"
                        attr.data-pw="item-{{ tab.title.toLowerCase() }}"
                    >
                        <ng-container
                            *ngTemplateOutlet="tagContent; context: { tab: tab, subTab: null }"
                            ngProjectAs="hive-tag"
                        />
                        <ng-container
                            *ngTemplateOutlet="badgeContent; context: { tab: tab, subTab: null }"
                            ngProjectAs="hive-badge"
                        />
                    </a>
                }
            }
        </hive-app-navigation-body>

        <hive-app-navigation-footer>
            <hive-app-navigation-item id="help" label="Help" [icon]="faCircleQuestion" (click)="ampli.helpClicked()">
                <ng-container ngProjectAs="[slot=children]">
                    @if (pageHelpUrl() != null) {
                        <a
                            hive-app-navigation-popup-item
                            label="Help with this page"
                            [href]="pageHelpUrl()"
                            target="_blank"
                            external
                            (click)="helpItemClick.emit('help with this page')"
                        ></a>
                        <hive-separator />
                    }
                    @if (canReadSupportKnowledge()) {
                        <a
                            hive-app-navigation-popup-item
                            label="Knowledge Base"
                            href="https://kb.purestorage.com/csm?ref=true"
                            target="_blank"
                            external
                            (click)="helpItemClick.emit('knowledge base')"
                        ></a>
                        <a
                            hive-app-navigation-popup-item
                            label="Documentation"
                            href="https://support.purestorage.com"
                            target="_blank"
                            external
                            (click)="helpItemClick.emit('documentation')"
                        ></a>
                    }
                    @if (canReadSupportCommunity()) {
                        <a
                            hive-app-navigation-popup-item
                            label="Community"
                            [href]="communityUrl()"
                            target="_blank"
                            external
                            (click)="helpItemClick.emit('community')"
                        ></a>
                    }
                </ng-container>
            </hive-app-navigation-item>

            <platform-app-navigation-app-switcher
                (visibilityChange)="appSwitcherVisibilityChange.emit($event)"
                (appClick)="appSwitcherAppClick.emit($event)"
            />
        </hive-app-navigation-footer>
    </hive-app-navigation>

    <!-- Page content from PageWrapperComponent. It stays in the shell's view and is checked with it. -->
    <ng-content />
</platform-page-layout>
